import { CategoryRestrictions, ProductCategoryFragment } from '@ocx/graphql';
import { ProductCategory } from './loyalty.types';

/**
 *  ProductCategories sorting by "rank" field
 *  If DisplayCategories has the same "rank" value - they should be sorted by "name"
 */
export const sortProductCategoriesByNameAndRank = (a: ProductCategoryFragment, b: ProductCategoryFragment) => {
  if (a.rank === b.rank) {
    return a.name.localeCompare(b.name);
  }
  return a.rank - b.rank;
};

export const isProductCategoryAgeRestricted = (category: ProductCategory): boolean => {
  if (!category.categoryRestriction) {
    return false;
  }
  return [CategoryRestrictions.Age, CategoryRestrictions.Eaiv].includes(category.categoryRestriction);
};
